import { Component } from "react";
import AddCostAllocationComponent from "../../../../../../common/custom-form/add-cost-allocation.component";

class BillingCostAllocation extends Component {
    render() {
        const { tableData, costAllocationfieldType,handleFetchCostAllocationData, financeId } = this.props;     
        return (
            <div>
                <AddCostAllocationComponent 
                    data={tableData}
                    fieldType={costAllocationfieldType}
                    handleFetchData= {handleFetchCostAllocationData}
                    financeId = { financeId }
                    isReadOnly={this.props.isReadOnly}
                    isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                    isReadAndWrite={this.props.isReadAndWrite}                                   
                />   
            </div>
        )
    }
}

export default BillingCostAllocation;